import { apiProvider } from '../utilities/provider';
import { ApiUrlConstants } from './apiUrl.constants';

export const vippsService = {
    mobileNoAndDeviceID,
    validateBrowserAuthCode
};

function mobileNoAndDeviceID(mobileNo, deviceId) {
    var model = {
        deviceUuid: deviceId,
        mobileNumber: mobileNo
    }
    return apiProvider.fetch.post(ApiUrlConstants.AccessControl.VippsEndPoint, model);
}

function validateBrowserAuthCode(model) {
    return apiProvider.fetch.post(ApiUrlConstants.AccessControl.VippsAuthEndPoint, model);
}  
